import { useIllustrationColor } from '../hooks/useIllustrationColor.hook';
import type { IllustrationProps } from '../types/props.type';

// https://undraw.co/search/dark-map
export const DarkMapIllustration = ({
  color: pColor,
  title = 'Carte',
}: Readonly<IllustrationProps>) => {
  const color = useIllustrationColor(pColor);

  return (
    <svg
      data-name="Layer 1"
      height="380"
      viewBox="0 140 721.11239 300"
      width="721.11239"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <path
        d="M719.63469,741.26733l-.153-.01452L480.3662,719.04034,262.93028,739.239a21.49791,21.49791,0,0,1-23.39415-19.41735q-.09207-.99134-.09215-1.988V200.70651a21.40162,21.40162,0,0,1,19.50937-21.40539l221.41288-20.56845.153.01452,239.11545,22.21245L937.06956,160.761a21.49792,21.49792,0,0,1,23.39429,19.41721q.0921.99142.09216,1.98819V699.29309a21.40186,21.40186,0,0,1-19.50927,21.40576Z"
        fill="#3f3d56"
        transform="translate(-239.4438 -158.73267)"
      />
      <path
        d="M572.76414,350.0441c-46.28643-33.7103-94.98727-65.67591-144.73815-95.00394l-2.49707-1.47175v99.46885H576.87376Zm-143.92791-.31421V259.36456c47.32852,27.9968,93.67273,58.37488,137.86749,90.36536Zm378.18,204.73386q-30.02664-31.21739-61.60767-61.01252Q736.702,485.22838,727.888,477.1377q-53.79025-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26672H809.712Zm-378.18-.50434V386.11087H615.18938q55.27881,42.99975,107.5639,90.81186,9.07855,8.29728,18.03345,16.727,31.3038,29.419,61.14459,60.30969Zm378.18.50434q-30.02664-31.21739-61.60767-61.01252Q736.702,485.22838,727.888,477.1377q-53.79025-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26672H809.712Zm-378.18-.50434V386.11087H615.18938q55.27881,42.99975,107.5639,90.81186,9.07855,8.29728,18.03345,16.727,31.3038,29.419,61.14459,60.30969ZM572.76414,350.0441c-46.28643-33.7103-94.98727-65.67591-144.73815-95.00394l-2.49707-1.47175v99.46885H576.87376Zm-143.92791-.31421V259.36456c47.32852,27.9968,93.67273,58.37488,137.86749,90.36536Zm143.92791.31421c-46.28643-33.7103-94.98727-65.67591-144.73815-95.00394l-2.49707-1.47175v99.46885H576.87376Zm-143.92791-.31421V259.36456c47.32852,27.9968,93.67273,58.37488,137.86749,90.36536Zm378.18,204.73386q-30.02664-31.21739-61.60767-61.01252Q736.702,485.22838,727.888,477.1377q-53.79025-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26672H809.712Zm-378.18-.50434V386.11087H615.18938q55.27881,42.99975,107.5639,90.81186,9.07855,8.29728,18.03345,16.727,31.3038,29.419,61.14459,60.30969ZM261.83113,587.033v3.30737H392.45531v47.95673H261.83113v3.30737H395.76265V587.033Zm163.69779,84.33771v33.51184l3.30737-.306V674.678H938.16978v-3.30737Zm512.64086-81.03034V587.033H425.52892v54.57147H938.16978v-3.30737H428.83626V590.34033Zm-308.866-240.6105A1613.79575,1613.79575,0,0,0,428.83626,217.6422v-33.487l-3.30738.30592v33.74622l2.54673,2.80012A1610.4861,1610.4861,0,0,1,627.73247,352.69l.44653.34726H938.16978v-3.30737Zm-236.84851,0H261.83113v3.30737H395.76265V187.22276l-3.30737.30593ZM938.16978,382.8035H665.65166l3.56372,2.927q50.32928,41.41231,98.832,87.84354,6.896,6.59811,13.74219,13.30383,34.08224,33.301,66.83355,68.77655l2.72663,1.61236h86.82v-3.30737H851.55821q-32.39565-35.12421-66.1969-68.21429-6.75906-6.623-13.56817-13.155-47.45271-45.53-96.93085-86.47922H938.16978ZM261.83113,671.37067V674.678H392.45531v33.272l3.30737-.30591V671.37067Zm0-288.56717v3.30737H392.45531V553.95941H261.83113v3.30737H395.76265V382.8035Zm310.933-32.7594c-46.28643-33.7103-94.98727-65.67591-144.73815-95.00394l-2.49707-1.47175v99.46885H576.87376Zm-143.92791-.31421V259.36456c47.32852,27.9968,93.67273,58.37488,137.86749,90.36536Zm378.18,204.73386q-30.02664-31.21739-61.60767-61.01252Q736.702,485.22838,727.888,477.1377q-53.79025-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26672H809.712Zm-378.18-.50434V386.11087H615.18938q55.27881,42.99975,107.5639,90.81186,9.07855,8.29728,18.03345,16.727,31.3038,29.419,61.14459,60.30969ZM572.76414,350.0441c-46.28643-33.7103-94.98727-65.67591-144.73815-95.00394l-2.49707-1.47175v99.46885H576.87376Zm-143.92791-.31421V259.36456c47.32852,27.9968,93.67273,58.37488,137.86749,90.36536Zm378.18,204.73386q-30.02664-31.21739-61.60767-61.01252Q736.702,485.22838,727.888,477.1377q-53.79025-49.412-111.11915-93.98694l-.44653-.34726H425.52892V557.26672H809.712Zm-378.18-.50434V386.11087H615.18938q55.27881,42.99975,107.5639,90.81186,9.07855,8.29728,18.03345,16.727,31.3038,29.419,61.14459,60.30969Z"
        fill="#fff"
        transform="translate(-239.4438 -158.73267)"
      />
      <path
        d="M608.77959,376.37775c0,41.88122-75.83267,135.18-75.83267,135.18s-75.83267-93.29876-75.83267-135.18a75.83267,75.83267,0,0,1,151.66534,0Z"
        fill={color}
        transform="translate(-239.4438 -158.73267)"
      />
      <path
        d="M567.61419,373.08068a34.66638,34.66638,0,1,1-34.66638-34.66638A34.65047,34.65047,0,0,1,567.61419,373.08068Z"
        fill="#fff"
        style={{ isolation: 'isolate' }}
        transform="translate(-239.4438 -158.73267)"
      />
      <circle cx="293.50312" cy="387.1146" fill={color} r="20.44185" />
      <circle cx="489.36398" cy="100.27214" fill="#ff6584" r="30.22324" />
      <path
        d="M823.58447,352.14173H675.31834a3.02384,3.02384,0,0,1-.55407-.0439l70.12308-121.46324a4.90981,4.90981,0,0,1,8.54664,0l47.06138,81.51127,2.25462,3.90031Z"
        fill="#fff"
        transform="translate(-239.4438 -158.73267)"
      />
      <polygon
        opacity="0.2"
        points="584.141 193.409 533.519 193.409 558.369 157.313 560.157 154.713 561.052 153.413 563.306 157.313 584.141 193.409"
        style={{ isolation: 'isolate' }}
      />
      <path
        d="M906.138,352.14173H777.9l24.85-36.09556,1.78829-2.60022,32.38181-47.03945c2.12294-3.08293,7.23007-3.27491,9.726-.58148a5.853,5.853,0,0,1,.46631.58148Z"
        fill="#fff"
        transform="translate(-239.4438 -158.73267)"
      />
      <circle cx="676.20989" cy="349.33488" fill="#fff" r="15.2965" />
      <polygon
        fill="#cbcbcb"
        points="677.685 395.409 674.552 395.409 675.98 347.031 677.685 395.409"
      />
      <polygon
        fill="#cbcbcb"
        points="676.256 356.2 679.62 351.546 676.21 357.352 675.842 356.707 676.256 356.2"
      />
      <polygon
        fill="#cbcbcb"
        points="675.888 360.899 672.524 356.246 675.934 362.051 676.302 361.406 675.888 360.899"
      />
      <circle cx="632.71557" cy="327.36152" fill="#fff" r="22.59163" />
      <polygon
        fill="#cbcbcb"
        points="634.893 395.409 630.266 395.409 632.376 323.959 634.893 395.409"
      />
      <polygon
        fill="#cbcbcb"
        points="632.784 337.5 637.751 330.628 632.716 339.202 632.172 338.249 632.784 337.5"
      />
      <polygon
        fill="#cbcbcb"
        points="632.24 344.441 627.272 337.569 632.308 346.142 632.852 345.19 632.24 344.441"
      />
      <circle cx="108.20989" cy="349.33488" fill="#fff" r="15.2965" />
      <polygon
        fill="#cbcbcb"
        points="109.685 395.409 106.552 395.409 107.98 347.031 109.685 395.409"
      />
      <polygon
        fill="#cbcbcb"
        points="108.256 356.2 111.62 351.546 108.21 357.352 107.842 356.707 108.256 356.2"
      />
      <polygon
        fill="#cbcbcb"
        points="107.888 360.899 104.524 356.246 107.934 362.051 108.302 361.406 107.888 360.899"
      />
      <circle cx="64.71557" cy="327.36152" fill="#fff" r="22.59163" />
      <polygon
        fill="#cbcbcb"
        points="66.893 395.409 62.266 395.409 64.376 323.959 66.893 395.409"
      />
      <polygon
        fill="#cbcbcb"
        points="64.784 337.5 69.751 330.628 64.716 339.202 64.172 338.249 64.784 337.5"
      />
      <polygon
        fill="#cbcbcb"
        points="64.24 344.441 59.272 337.569 64.308 346.142 64.852 345.19 64.24 344.441"
      />
    </svg>
  );
};
